module.exports = __webpack_public_path__ + "img/Moony Tseng.378b1efb.jpg";